import React from 'react';
// import styles from './styles.module.scss';
import { Checkbox } from '@lion-design/core';

export interface ItemInfo {
    text: number | string; // 項目名稱
    value: number | string; // 項目value
    filterType?: string; // 項目所屬大項
}

export interface FilterItemProps extends ItemInfo {
    note?: string;
    isDisable: boolean; // 是否要disabled
    key?: number | string;
    onChanged?: (params: string) => void;
    isCheck: number | null;
}

const CheckboxItem: React.FC<FilterItemProps> = ({ text, isDisable, note, isCheck }) => {
    // const dispatch = useDispatch();
    // const { FilterItems } = useSelector((state: RootState) => state.search);
    // const isCheck = FilterItems.filter((item: I_FilterItem) => {
    //     return item.value == value; // value 可能是string or number 不可用===
    // });
    const itemInfo = () => {
        return (
            <>
                <span>{text}</span>
                {/* {note && <span className={styles.Note}>{note}</span>} */}
            </>
        );
    };

    const checkboxProps = {
        // onChange: handleChange,
        checked: isCheck !== -1,
        title: <span dangerouslySetInnerHTML={{ __html: text }} />,
        disabled: isDisable,
        checkFillColor: '#f03742', //勾勾顏色
        checkedBackgroundColor: 'transparent', //勾起來的時候的背景色
    };

    return <Checkbox {...checkboxProps} />;
};

export { CheckboxItem };
